import React from 'react';
import banner from './img/courses-bannner.png'
import './EthicalPage.css';
import CareerForm from './careerform';
import Footer from '../Components/footer'

const ciscoPage = () => {
  return (
    <div className='cisco-container'>
       <div className='cisco-banner-box'>
                  <div className='cisco-banner'>
        <img src={banner} alt=''/>
                  </div>
                </div>

<div className='detail-box'>
    <div className='cisco-heading'>
        <h1>Ethical Hacking Course </h1>
        <p>Ethical hacking is the authorized practice of testing systems, networks, and applications to identify and fix security weaknesses before malicious attackers exploit them. Ethical hackers use real hacking techniques with permission to strengthen cybersecurity and protect digital assets.
</p>
        </div> 
        
        <div className='carrer-section'>
        <div className='skills-section'>
<h2>🛡️ Top Ethical Hacking Skills You’ll Master</h2>
<div className='skills-name'>
<span>Cybersecurity fundamentals</span>
<span>Footprinting and reconnaissance</span>
</div>
<div className='skills-name'>
<span>Network scanning and enumeration</span>
<span>Web application security (OWASP Top 10)</span>
</div>
<div className='skills-name'>
<span>Wireless security and social engineering</span>
</div>

        </div>
 <div className='job-roles'>
           <h1>💼 JOB ROLES AFTER COURSE</h1>
           <div className='job-name'>
            <span>Ethical Hacker</span>
            <span>Cyber Analyst</span>
            </div>
             <div className='job-name'>
            <span>Security Engineer</span>
            <span>Security Consultant</span>
            </div>
             <div className='job-name'>
            <span>SOC Analyst </span>
           </div>
        </div>
        </div>
        <div className='course-discription'>
            <h1>About this Course</h1>
<p>Ethical hacking is the practice of performing security assessments using the same techniques that hackers use but with proper approvals and authorisation from the organisation you’re hacking into. The goal is to use cybercriminals’ tactics, techniques, and strategies to locate potential weaknesses and reinforce an organisation’s protection from data and security breaches. New viruses, malware, ransomware, and worms are emerging all the time. Ethical hackers help safeguard government agencies, defence departments, and business networks. The main benefit of ethical hacking is reducing the risk of data theft. An ethical hacking course teaches you how to legally simulate cyberattacks to find and fix security vulnerabilities before malicious hackers can exploit them. It covers penetration testing, system defenses, and industry-recognized hacking tools to help protect critical data and networks.

</p>
        </div>
        </div>
        <div className='join-container'>
        <div className='join-box'>
<div className='join-div'>
<h1>Who Should Join This Ethical Hacking Course</h1>
<p><span> ✔ </span>Students who want to learn how hackers think and how to stop them. </p>
<p><span> ✔ </span>Freshers ready to start a smart career in ethical hacking & security.</p>
<p><span> ✔ </span>Beginners who want to step into hacking world in a safe and legal way.</p>
<p><span> ✔ </span>Tech learners excited to find and fix security weaknesses. </p>
<p><span> ✔ </span> IT beginners aiming to build strong skills in cyber protection.</p>
<p><span> ✔ </span>Working professionals planning to switch into ethical hacking roles.</p>
<p><span> ✔ </span>Support engineers who want to upgrade into security-focused jobs.</p>
<p><span> ✔ </span>Freelancers who want to offer website and system security services. </p>
<p><span> ✔ </span>Self-learners looking for a clear, practical and guided hacking journey.</p>
<p><span> ✔ </span>Anyone who wants to protect data, stop attacks and build a powerful career.</p>
</div>
        </div>

                <CareerForm/>
        </div>

    <div className="modules-container">

      {/* Heading */}
      <h1 className="module">Course RoadMap</h1>
      <p className="subtitle">
        Step-by-step modules to master Ethical Hacking Course
      </p>

      {/* Grid */}
      <div className="modules-grid">

        {/* Card 1 */}
        <div className="module-card">
          <div className="circle">01</div>
          <h3>Ethical Hacking Overview</h3>
          <p>
           Understand ethical hacking concepts, methodologies, and cybersecurity career opportunities clearly.

          </p>
        </div>

        {/* Card 2 */}
        <div className="module-card">
          <div className="circle">02</div>
          <h3>Footprinting & Reconnaissance</h3>
          <p>
            Gather target information using passive and active reconnaissance techniques effectively.
          </p>
        </div>

        {/* Card 3 */}
        <div className="module-card">
          <div className="circle">03</div>
          <h3>Scanning Networks</h3>
          <p>
           Identify live hosts, open ports, and vulnerabilities using network scanning tools.
          </p>
        </div>

        {/* Card 4 */}
        <div className="module-card">
          <div className="circle">04</div>
          <h3>Enumeration Techniques</h3>
          <p>
           Extract system details, users, and services for deeper vulnerability assessment.
          </p>
        </div>

        {/* Card 5 */}
        <div className="module-card">
          <div className="circle">05</div>
          <h3>System Hacking</h3>
          <p>
          Learn password cracking, privilege escalation, and maintaining system access techniques.
          </p>
        </div>

        {/* Card 6 */}
        <div className="module-card">
          <div className="circle">06</div>
          <h3>Malware & Threats</h3>
          <p>
            Understand malware types, attacks, and basic analysis of malicious software behavior.
          </p>
        </div>

      </div>

        {/* Grid */}
      <div className="modules-grid">

        {/* Card 7 */}
        <div className="module-card">
          <div className="circle">07</div>
          <h3>Sniffing & Network Attacks</h3>
          <p>
            Capture network traffic and analyze packets to identify security vulnerabilities.
          </p>
        </div>

        {/* Card 8 */}
        <div className="module-card">
          <div className="circle">08</div>
          <h3>Social Engineering</h3>
          <p>
           Learn human-based attack techniques and methods to prevent security breaches.
          </p>
        </div>

        {/* Card 9 */}
        <div className="module-card">
          <div className="circle">09</div>
          <h3>Web Application Security</h3>
          <p>
          Identify web vulnerabilities like SQL injection, XSS, and secure applications.
          </p>
        </div>

        {/* Card 10 */}
        <div className="module-card">
          <div className="circle">10</div>
          <h3>Wireless Network Security</h3>
          <p>
           Analyze Wi-Fi vulnerabilities and implement security measures against wireless attacks.
          </p>
        </div>

        {/* Card 11 */}
        <div className="module-card">
          <div className="circle">11</div>
          <h3>Cryptography Basics</h3>
          <p>
           Understand encryption, hashing, and secure data communication techniques in cybersecurity.
          </p>
        </div>

        {/* Card 12 */}
        <div className="module-card">
          <div className="circle">12</div>
          <h3>Penetration Testing & Reporting</h3>
          <p>
        Perform penetration testing and create professional vulnerability assessment reports.
Ethical hacking
          </p>
        </div>

      </div>
    </div>

<div>
        <Footer/>
</div>
    </div>
  )
}

export default ciscoPage